import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import ScrollOut from 'scroll-out';

@Component({
  selector: 'app-counter',
  templateUrl: './counter.component.html',
  styleUrls: ['./counter.component.scss']
})
export class CounterComponent implements OnInit, OnDestroy, AfterViewInit {

  so: any;
  countersStarted = false;

  constructor() {}

  ngOnInit(): void {
    this.so = ScrollOut({
      onShown: (el: any) => {
        el.classList.remove('animated');
        void el.offsetWidth;
        el.classList.add('animated');
      }
    });
  }

  ngAfterViewInit(): void {
    window.addEventListener('scroll', this.checkIfInView.bind(this));
  }

  ngOnDestroy(): void {
    this.so.teardown();
    window.removeEventListener('scroll', this.checkIfInView.bind(this));
  }

  /** Count number animation */
  animateCounters(): void {
    const counters = document.querySelectorAll('.count');

    counters.forEach((counter: any) => {
      const target = +counter.getAttribute('data-count');
      let current = 0;
      const speed = Math.max(target / 100, 5); // smooth speed for big values

      const update = () => {
        if (current < target) {
          current += speed;
          counter.innerText = Math.floor(current);
          requestAnimationFrame(update);
        } else {
          counter.innerText = target;
        }
      };

      update();
    });
  }

  /** Trigger animation only when in view */
  checkIfInView(): void {
    if (this.countersStarted) return;

    const section = document.querySelector('#counter');
    if (!section) return;

    const rect = section.getBoundingClientRect();
    if (rect.top < window.innerHeight - 100) {
      this.animateCounters();
      this.countersStarted = true;
    }
  }
}
